var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page landscape"},[_c('div',{staticClass:"background"}),_c('Logo'),_c('h1',[_vm._v("Pricing")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }